export default "__VITE_ASSET__C_w4Cdcd__"